import React, { useCallback } from 'react';
import { Redirect, RouteComponentProps } from 'react-router';
import { checkIsMarketMultilingual, LanguageCode, MarketCode } from '@tink/config/src/markets';
import { LegalTemplate } from '../organisms/LegalTemplate/LegalTemplate';
import { isChromeless } from '../atoms/isChromeless';
import { defaultLegalTextUrlMap, legalTextUrlMap } from '../LegalDocUrls';

/**
 * Returns the specific T&C url for the market.
 * If multilingual, it checks if the active language is given, if not, the default will be shipped.
 * If non fits, the English version will be returned.
 * @param market
 * @param language
 */

export const getTermsAndConditionsMarketUrl = ({
  market,
  language,
}: {
  market: MarketCode;
  language: LanguageCode;
}) => {
  // Set default will be the fallback
  let { termsConditionsUrl } = defaultLegalTextUrlMap;
  const marketLegalUrlMap = legalTextUrlMap[market];

  if (marketLegalUrlMap) {
    if (marketLegalUrlMap.length > 0) {
      termsConditionsUrl = marketLegalUrlMap[0].termsConditionsUrl;
    }

    if (checkIsMarketMultilingual(market)) {
      const selectedMarketTermsConditions = marketLegalUrlMap.find(
        (el) => el.language === language
      );

      if (selectedMarketTermsConditions?.termsConditionsUrl) {
        termsConditionsUrl = selectedMarketTermsConditions.termsConditionsUrl;
      }
    }
  }

  return termsConditionsUrl;
};

export const TermsAndConditionsMarket = ({
  match,
  history,
  location: { search },
}: RouteComponentProps<{ lang: LanguageCode; market: MarketCode }>) => {
  const { market, lang } = match.params;

  const chromeless = isChromeless(search);

  const onBack = useCallback(() => {
    history.goBack();
  }, [history]);

  const termsAndConditionsUrl = getTermsAndConditionsMarketUrl({ market, language: lang });

  if (!termsAndConditionsUrl) {
    return <Redirect to="/terms-and-conditions/en" />;
  }

  return (
    <LegalTemplate onBack={onBack} documentUrl={termsAndConditionsUrl} chromeless={chromeless} />
  );
};
